import dayjs from 'dayjs';
export const checkColor = (
  variationPercentage,
  data,
  currentMonthTarget,
  previousMonthTarget,
  compareType
) => {
  if (
    !data ||
    !data.date ||
    !data.value ||
    // data.value == 0 ||
    data.value == 'NaN'
  )
    return '';

  let dateStr = dayjs(data?.date).format('YYYY-MM');
  let compareMonthTarget =
    dateStr == dayjs(currentMonthTarget?.date).format('YYYY-MM')
      ? currentMonthTarget
      : previousMonthTarget;

  return getClassColor(
    data,
    compareMonthTarget,
    variationPercentage,
    compareType
  );
};
const getClassColor = (
  data,
  compareMonthTarget,
  variationPercentage,
  compareType
) => {
  const value = parseFloat((data?.value || '').replace(/,/g, ''), 10) || 0;
  const target =
    parseFloat((compareMonthTarget?.target || '').replace(/,/g, ''), 10) || 0;

  if (!variationPercentage || variationPercentage == 0) {
    if (value == target) {
      return 'kpiWarning';
    }
    if (compareType === 0) {
      return value > target ? 'kpiSafe' : 'kpiDanger';
    } else {
      return value > target ? 'kpiDanger' : 'kpiSafe';
    }
  }
  if (target === 0) {
    if (value === 0) {
      return 'kpiSafe';
    }
    return 'kpiDanger';
  }

  let lowerBound = target * (1 - variationPercentage / 100);
  if (compareType === 0) {
    if (value > target) {
      return 'kpiSafe';
    } else if (value >= lowerBound && value <= target) {
      return 'kpiWarning';
    } else {
      return 'kpiDanger';
    }
  } else if (compareType === 1) {
    let upperBound = target * (1 + variationPercentage / 100);
    if (value < target) {
      return 'kpiSafe';
    } else if (value <= upperBound) {
      return 'kpiWarning';
    } else {
      return 'kpiDanger';
    }
  }

  return '';
};
